import { GraphQLClient } from 'graphql-request'
import * as Dom from 'graphql-request/dist/types.dom'
import gql from 'graphql-tag'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  Address: string
  Blockchain: string
  Decimal: string
  Hash: string
  Session: string
  Time: string
}

export enum AccessType {
  Private = 'Private',
  Public = 'Public',
}

export type AccountVesting = {
  __typename?: 'AccountVesting'
  available: Array<Scalars['Decimal']>
  claimed: Array<Scalars['Decimal']>
  totalAvailable: Scalars['Decimal']
  totalClaimed: Scalars['Decimal']
  unlocks: Array<Scalars['Decimal']>
}

export type AuthInput = {
  authMessage: Scalars['String']
  sign: Scalars['String']
}

export type AuthResult = {
  __typename?: 'AuthResult'
  address: Scalars['Address']
  session: Scalars['Session']
}

export type Balance = {
  __typename?: 'Balance'
  amount: Scalars['Decimal']
  token: Token
}

export type Epoch = {
  __typename?: 'Epoch'
  rewardsPerSecond: Scalars['Decimal']
  startTime: Scalars['Time']
}

export type FixedPricePool = Pool & {
  __typename?: 'FixedPricePool'
  accessType: AccessType
  account?: Maybe<PoolAccount>
  address: Scalars['Address']
  blockchain: Scalars['Blockchain']
  currentTime: Scalars['Time']
  id: Scalars['ID']
  idoToken: Token
  meta: PoolMeta
  minOrderSizeTargetToken: Scalars['Decimal']
  pipeline: PoolPipeline
  poolStatus: PoolStatus
  poolType: PoolType
  price?: Maybe<Scalars['Decimal']>
  priceReverse?: Maybe<Scalars['Decimal']>
  progress: PoolProgress
  projectAdmin?: Maybe<Scalars['Address']>
  stakingAddress: Scalars['Address']
  statistics: PoolStatistics
  targetToken?: Maybe<Token>
  tiers: Array<Tier>
  verifiedStatus: VerifiedStatus
  vesting?: Maybe<Vesting>
  waves?: Maybe<PoolWaves>
  whitelistAddress: Scalars['Address']
}

export type KycInfo = {
  __typename?: 'KycInfo'
  generalLink: Scalars['String']
  lastSyncTime?: Maybe<Scalars['Time']>
  rejectType?: Maybe<KycRejectType>
  resubmitLink: Scalars['String']
  status: KycStatus
  supportLink: Scalars['String']
  usInvestorsLink: Scalars['String']
}

export enum KycRejectType {
  Final = 'Final',
  Retry = 'Retry',
}

export enum KycStatus {
  Approved = 'Approved',
  Empty = 'Empty',
  Rejected = 'Rejected',
}

export type Member = {
  __typename?: 'Member'
  avatar: Scalars['String']
  linkedIn: Scalars['String']
  name: Scalars['String']
  position: Scalars['String']
}

export type Mutation = {
  __typename?: 'Mutation'
  auth: AuthResult
  getAuthMessage: Scalars['String']
  registerPoolParticipation: PoolParticipationResponse
}

export type MutationAuthArgs = {
  input: AuthInput
}

export type MutationGetAuthMessageArgs = {
  address: Scalars['Address']
}

export type MutationRegisterPoolParticipationArgs = {
  input: RegisterPoolParticipationInput
}

export type Pool = {
  /** @deprecated use meta.private */
  accessType: AccessType
  account?: Maybe<PoolAccount>
  address: Scalars['Address']
  blockchain: Scalars['Blockchain']
  currentTime: Scalars['Time']
  id: Scalars['ID']
  idoToken: Token
  meta: PoolMeta
  minOrderSizeTargetToken: Scalars['Decimal']
  pipeline: PoolPipeline
  poolStatus: PoolStatus
  poolType: PoolType
  price?: Maybe<Scalars['Decimal']>
  /** @deprecated Field no longer supported */
  priceReverse?: Maybe<Scalars['Decimal']>
  progress: PoolProgress
  projectAdmin?: Maybe<Scalars['Address']>
  /** @deprecated Field no longer supported */
  stakingAddress: Scalars['Address']
  statistics: PoolStatistics
  targetToken?: Maybe<Token>
  tiers: Array<Tier>
  /** @deprecated use meta.isIncubated */
  verifiedStatus: VerifiedStatus
  vesting?: Maybe<Vesting>
  waves?: Maybe<PoolWaves>
  whitelistAddress: Scalars['Address']
}

export type PoolAccount = {
  __typename?: 'PoolAccount'
  account: Scalars['String']
  amountPaid: Scalars['Decimal']
  /** @deprecated use vesting.totalClaimed */
  claimAmount: Scalars['Decimal']
  id: Scalars['ID']
  idoTokenBalance: Scalars['Decimal']
  isRegistered: Scalars['Boolean']
  isWhitelisted?: Maybe<Scalars['Boolean']>
  refundAmount: Scalars['Decimal']
  targetTokenBalance: Scalars['Decimal']
  tier?: Maybe<Tier>
  userToReserve: Scalars['Decimal']
  vesting?: Maybe<AccountVesting>
  /** @deprecated use account.idoTokenBalance instead */
  walletBalance: Scalars['Decimal']
  wave?: Maybe<Scalars['Int']>
  waveStartTime?: Maybe<Scalars['Time']>
  withdrawnAmount: Scalars['Decimal']
}

export type PoolMeta = {
  __typename?: 'PoolMeta'
  ROIAllTimeHigh?: Maybe<Scalars['Decimal']>
  auditReport?: Maybe<Scalars['String']>
  brandBackground?: Maybe<Scalars['String']>
  brandLogo?: Maybe<Scalars['String']>
  coingecko?: Maybe<Scalars['String']>
  coinmarketcap?: Maybe<Scalars['String']>
  constantUSDTokenPrice?: Maybe<Scalars['Decimal']>
  constantUSDTotalTarget?: Maybe<Scalars['Decimal']>
  coolOffExplainedLink: Scalars['String']
  description: Scalars['String']
  discord?: Maybe<Scalars['String']>
  dueDiligenceReport?: Maybe<Scalars['String']>
  /** @deprecated use constantUSDTokenPrice */
  idoTokenPriceUSD?: Maybe<Scalars['Decimal']>
  initialCirculationAmount?: Maybe<Scalars['Decimal']>
  initialMarketCap?: Maybe<Scalars['Decimal']>
  initialMarketCapUSD?: Maybe<Scalars['Decimal']>
  isIncubated?: Maybe<Scalars['Boolean']>
  isKYCRequired: Scalars['Boolean']
  markdown?: Maybe<Scalars['String']>
  medium?: Maybe<Scalars['String']>
  name: Scalars['String']
  participationExplainedLink: Scalars['String']
  position?: Maybe<Scalars['Int']>
  prelaunchStart?: Maybe<Scalars['Time']>
  priceAllTimeHigh?: Maybe<Scalars['Decimal']>
  private: Scalars['Boolean']
  registrationStart?: Maybe<Scalars['Time']>
  roughTokenPriceUSD?: Maybe<Scalars['Decimal']>
  secondaryMarkets: Array<SecondaryMarket>
  sourceCode?: Maybe<Scalars['String']>
  subtitle?: Maybe<Scalars['String']>
  tags: Array<Scalars['String']>
  team: Array<Member>
  telegram?: Maybe<Scalars['String']>
  tiersExplainedLink: Scalars['String']
  twitter?: Maybe<Scalars['String']>
  vestingDescription?: Maybe<Scalars['String']>
  video?: Maybe<Scalars['String']>
  visibility: Scalars['Boolean']
  website?: Maybe<Scalars['String']>
  whitelistingStart?: Maybe<Scalars['Time']>
  whitepaper?: Maybe<Scalars['String']>
}

export type PoolParticipationResponse = {
  __typename?: 'PoolParticipationResponse'
  reason?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type PoolPipeline = {
  __typename?: 'PoolPipeline'
  /** @deprecated use vesting.unlockCheckpoints[0] */
  claimTime?: Maybe<Scalars['Time']>
  finishTime?: Maybe<Scalars['Time']>
  prelaunchTime?: Maybe<Scalars['Time']>
  registrationTime?: Maybe<Scalars['Time']>
  startTime?: Maybe<Scalars['Time']>
  whitelistingTime?: Maybe<Scalars['Time']>
}

export type PoolProgress = {
  __typename?: 'PoolProgress'
  softCap?: Maybe<Scalars['Decimal']>
  softCapPercent?: Maybe<Scalars['Decimal']>
  tokensSoftCap?: Maybe<Scalars['Decimal']>
  tokensSold?: Maybe<Scalars['Decimal']>
  tokensToSell?: Maybe<Scalars['Decimal']>
  totalRaised?: Maybe<Scalars['Decimal']>
  totalTarget?: Maybe<Scalars['Decimal']>
  totalTargetUSD?: Maybe<Scalars['Decimal']>
}

export type PoolStatistics = {
  __typename?: 'PoolStatistics'
  /** @deprecated Field no longer supported */
  marketcapEstimate?: Maybe<Scalars['Decimal']>
  participantsCount: Scalars['Int']
  registeredCount: Scalars['Int']
}

export enum PoolStatus {
  ComingSoon = 'ComingSoon',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Paused = 'Paused',
  Prelaunch = 'Prelaunch',
  Registration = 'Registration',
  SoldOut = 'SoldOut',
  SuccessfullyFinished = 'SuccessfullyFinished',
  Whitelisting = 'Whitelisting',
}

export enum PoolType {
  FixedPricePool = 'FixedPricePool',
}

export type PoolWavePipeline = {
  __typename?: 'PoolWavePipeline'
  number: Scalars['Int']
  start: Scalars['Time']
}

export type PoolWaves = {
  __typename?: 'PoolWaves'
  currentWave?: Maybe<Scalars['Int']>
  pipeline: Array<PoolWavePipeline>
}

export type Query = {
  __typename?: 'Query'
  kycInfo: KycInfo
  pools: Array<Pool>
  stakingInfo: StakingInfo
  stakingInfoWithoutSession: StakingInfo
}

export type QueryKycInfoArgs = {
  session: Scalars['Session']
}

export type QueryPoolsArgs = {
  session?: InputMaybe<Scalars['Session']>
}

export type QueryStakingInfoArgs = {
  address?: InputMaybe<Scalars['Address']>
  blockchain?: InputMaybe<Scalars['Blockchain']>
  session?: InputMaybe<Scalars['Session']>
}

export type QueryStakingInfoWithoutSessionArgs = {
  account?: InputMaybe<Scalars['Address']>
  address?: InputMaybe<Scalars['Address']>
  blockchain?: InputMaybe<Scalars['Blockchain']>
}

export type QueryStaking = {
  __typename?: 'QueryStaking'
  stakingInfo: StakingInfo
  stakingInfoWithoutSession: StakingInfo
}

export type QueryStakingStakingInfoArgs = {
  address?: InputMaybe<Scalars['Address']>
  blockchain?: InputMaybe<Scalars['Blockchain']>
  session?: InputMaybe<Scalars['Session']>
}

export type QueryStakingStakingInfoWithoutSessionArgs = {
  account?: InputMaybe<Scalars['Address']>
  address?: InputMaybe<Scalars['Address']>
  blockchain?: InputMaybe<Scalars['Blockchain']>
}

export type RegisterPoolParticipationInput = {
  blockchain: Scalars['Blockchain']
  poolAddress: Scalars['Address']
  session: Scalars['Session']
}

export type SecondaryMarket = {
  __typename?: 'SecondaryMarket'
  name: Scalars['String']
  sellStart?: Maybe<Scalars['Time']>
  url: Scalars['String']
}

export type StakeBooster = {
  __typename?: 'StakeBooster'
  boosterUnlockTime: Scalars['Time']
  stakeBoosterBalance: Scalars['Decimal']
  stakeBoosterThreshold: Scalars['Decimal']
}

export type StakingAccount = {
  __typename?: 'StakingAccount'
  account: Scalars['Address']
  allowance: Scalars['Decimal']
  rewardAvailable: Scalars['Decimal']
  rewardClaimed: Scalars['Decimal']
  rewardPending: Scalars['Decimal']
  rewardTotal: Scalars['Decimal']
  rewardTotalUSD: Scalars['Decimal']
  stakeBooster?: Maybe<StakeBooster>
  stakingBalance: Scalars['Decimal']
  tier?: Maybe<StakingTier>
  walletBalance: Scalars['Decimal']
}

export type StakingInfo = {
  __typename?: 'StakingInfo'
  account?: Maybe<StakingAccount>
  address: Scalars['Address']
  apy: Scalars['Decimal']
  blockchain: Scalars['Blockchain']
  contract: Scalars['String']
  currentEpoch?: Maybe<Epoch>
  id: Scalars['ID']
  nextEpoch?: Maybe<Epoch>
  priceRewardTokenUSD: Scalars['Decimal']
  priceStakingTokenUSD: Scalars['Decimal']
  rewardToken: Token
  sessionError?: Maybe<Scalars['String']>
  stakingToken: Token
  tiers: Array<StakingTier>
  totalEmittedRewards: Scalars['Decimal']
  totalRewardToDistribute?: Maybe<Scalars['Decimal']>
  totalStaked: Scalars['Decimal']
  uniqueStakers: Scalars['Int']
  unstakingFeeRatio: Scalars['Decimal']
}

export type StakingTier = {
  __typename?: 'StakingTier'
  allocationMultiple: Scalars['Decimal']
  coolOff?: Maybe<Scalars['Int']>
  index: Scalars['Int']
  isSpecial?: Maybe<Scalars['Boolean']>
  level: Scalars['Int']
  minStake: Scalars['Decimal']
  name: Scalars['String']
  participationTickets: Scalars['Decimal']
  stakeDelta?: Maybe<Scalars['Decimal']>
  ticketDelta?: Maybe<Scalars['Decimal']>
}

export type Tier = {
  __typename?: 'Tier'
  allocationMultiple: Scalars['Decimal']
  coolOff: Scalars['Int']
  index: Scalars['Int']
  isSpecial?: Maybe<Scalars['Boolean']>
  level: Scalars['Int']
  maxAllocation?: Maybe<Scalars['Decimal']>
  minStake?: Maybe<Scalars['Decimal']>
  name: Scalars['String']
  /** @deprecated use participationTickets */
  participationChanceFrom: Scalars['Int']
  /** @deprecated use participationTickets */
  participationChanceTo: Scalars['Int']
  participationTickets: Scalars['Decimal']
}

export type Token = {
  __typename?: 'Token'
  address: Scalars['Address']
  blockchain: Scalars['Blockchain']
  decimals: Scalars['Int']
  id: Scalars['ID']
  name: Scalars['String']
  symbol: Scalars['String']
  totalSupply: Scalars['Decimal']
}

export enum VerifiedStatus {
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED',
}

export type Vesting = {
  __typename?: 'Vesting'
  currentPeriodIndex?: Maybe<Scalars['Int']>
  unlockCheckpoints: Array<Scalars['Time']>
  unlockPercentages: Array<Scalars['Decimal']>
  unlockPercentagesByCheckpoint: Array<Scalars['Decimal']>
  viaAirdrop: Scalars['Boolean']
}

export type AuthMutationVariables = Exact<{
  input: AuthInput
}>

export type AuthMutation = {
  __typename?: 'Mutation'
  auth: { __typename?: 'AuthResult'; session: string; address: string }
}

export type GetAuthMessageMutationVariables = Exact<{
  address: Scalars['Address']
}>

export type GetAuthMessageMutation = {
  __typename?: 'Mutation'
  getAuthMessage: string
}

export type RegisterPoolParticipationMutationVariables = Exact<{
  input: RegisterPoolParticipationInput
}>

export type RegisterPoolParticipationMutation = {
  __typename?: 'Mutation'
  registerPoolParticipation: {
    __typename?: 'PoolParticipationResponse'
    reason?: string | null
    success: boolean
  }
}

export type GeneralInfoQueryVariables = Exact<{
  session?: InputMaybe<Scalars['Session']>
}>

export type GeneralInfoQuery = {
  __typename?: 'Query'
  pools: Array<{
    __typename?: 'FixedPricePool'
    address: string
    blockchain: string
    currentTime: string
    id: string
    whitelistAddress: string
    projectAdmin?: string | null
    price?: string | null
    poolStatus: PoolStatus
    poolType: PoolType
    minOrderSizeTargetToken: string
    account?: {
      __typename?: 'PoolAccount'
      account: string
      amountPaid: string
      claimAmount: string
      id: string
      idoTokenBalance: string
      isRegistered: boolean
      isWhitelisted?: boolean | null
      refundAmount: string
      targetTokenBalance: string
      userToReserve: string
      wave?: number | null
      waveStartTime?: string | null
      withdrawnAmount: string
      tier?: {
        __typename?: 'Tier'
        allocationMultiple: string
        coolOff: number
        index: number
        isSpecial?: boolean | null
        level: number
        maxAllocation?: string | null
        minStake?: string | null
        name: string
        participationTickets: string
      } | null
      vesting?: {
        __typename?: 'AccountVesting'
        available: Array<string>
        claimed: Array<string>
        totalAvailable: string
        totalClaimed: string
        unlocks: Array<string>
      } | null
    } | null
    idoToken: {
      __typename?: 'Token'
      address: string
      blockchain: string
      decimals: number
      id: string
      name: string
      symbol: string
      totalSupply: string
    }
    waves?: {
      __typename?: 'PoolWaves'
      currentWave?: number | null
      pipeline: Array<{
        __typename?: 'PoolWavePipeline'
        number: number
        start: string
      }>
    } | null
    vesting?: {
      __typename?: 'Vesting'
      currentPeriodIndex?: number | null
      unlockCheckpoints: Array<string>
      unlockPercentages: Array<string>
      viaAirdrop: boolean
    } | null
    tiers: Array<{
      __typename?: 'Tier'
      allocationMultiple: string
      coolOff: number
      index: number
      isSpecial?: boolean | null
      level: number
      maxAllocation?: string | null
      minStake?: string | null
      name: string
      participationTickets: string
    }>
    meta: {
      __typename?: 'PoolMeta'
      ROIAllTimeHigh?: string | null
      auditReport?: string | null
      brandBackground?: string | null
      brandLogo?: string | null
      coingecko?: string | null
      coinmarketcap?: string | null
      constantUSDTotalTarget?: string | null
      description: string
      discord?: string | null
      dueDiligenceReport?: string | null
      initialCirculationAmount?: string | null
      initialMarketCap?: string | null
      isIncubated?: boolean | null
      isKYCRequired: boolean
      markdown?: string | null
      medium?: string | null
      name: string
      position?: number | null
      prelaunchStart?: string | null
      priceAllTimeHigh?: string | null
      private: boolean
      registrationStart?: string | null
      sourceCode?: string | null
      subtitle?: string | null
      tags: Array<string>
      telegram?: string | null
      twitter?: string | null
      vestingDescription?: string | null
      video?: string | null
      visibility: boolean
      website?: string | null
      whitelistingStart?: string | null
      whitepaper?: string | null
      coolOffExplainedLink: string
      tiersExplainedLink: string
      roughTokenPriceUSD?: string | null
      participationExplainedLink: string
      constantUSDTokenPrice?: string | null
      secondaryMarkets: Array<{
        __typename?: 'SecondaryMarket'
        name: string
        sellStart?: string | null
        url: string
      }>
      team: Array<{
        __typename?: 'Member'
        avatar: string
        linkedIn: string
        name: string
        position: string
      }>
    }
    targetToken?: {
      __typename?: 'Token'
      address: string
      blockchain: string
      decimals: number
      id: string
      name: string
      symbol: string
      totalSupply: string
    } | null
    statistics: {
      __typename?: 'PoolStatistics'
      participantsCount: number
      registeredCount: number
    }
    progress: {
      __typename?: 'PoolProgress'
      softCapPercent?: string | null
      tokensSoftCap?: string | null
      tokensSold?: string | null
      tokensToSell?: string | null
      totalTarget?: string | null
      totalTargetUSD?: string | null
    }
    pipeline: {
      __typename?: 'PoolPipeline'
      finishTime?: string | null
      prelaunchTime?: string | null
      registrationTime?: string | null
      startTime?: string | null
      whitelistingTime?: string | null
    }
  }>
  stakingInfo: {
    __typename?: 'StakingInfo'
    address: string
    apy: string
    contract: string
    id: string
    sessionError?: string | null
    totalEmittedRewards: string
    totalRewardToDistribute?: string | null
    totalStaked: string
    unstakingFeeRatio: string
    account?: {
      __typename?: 'StakingAccount'
      account: string
      allowance: string
      rewardAvailable: string
      rewardClaimed: string
      rewardTotal: string
      rewardTotalUSD: string
      stakingBalance: string
      walletBalance: string
      stakeBooster?: {
        __typename?: 'StakeBooster'
        boosterUnlockTime: string
        stakeBoosterBalance: string
        stakeBoosterThreshold: string
      } | null
      tier?: {
        __typename?: 'StakingTier'
        allocationMultiple: string
        coolOff?: number | null
        index: number
        isSpecial?: boolean | null
        level: number
        minStake: string
        name: string
        participationTickets: string
        stakeDelta?: string | null
        ticketDelta?: string | null
      } | null
    } | null
    currentEpoch?: {
      __typename?: 'Epoch'
      rewardsPerSecond: string
      startTime: string
    } | null
    nextEpoch?: {
      __typename?: 'Epoch'
      rewardsPerSecond: string
      startTime: string
    } | null
    rewardToken: {
      __typename?: 'Token'
      address: string
      blockchain: string
      decimals: number
      id: string
      name: string
      symbol: string
      totalSupply: string
    }
    stakingToken: {
      __typename?: 'Token'
      address: string
      blockchain: string
      decimals: number
      id: string
      name: string
      symbol: string
      totalSupply: string
    }
    tiers: Array<{
      __typename?: 'StakingTier'
      allocationMultiple: string
      coolOff?: number | null
      index: number
      isSpecial?: boolean | null
      level: number
      minStake: string
      name: string
      participationTickets: string
      stakeDelta?: string | null
      ticketDelta?: string | null
    }>
  }
}

export type GeneralInfoWithKycQueryVariables = Exact<{
  session: Scalars['Session']
}>

export type GeneralInfoWithKycQuery = {
  __typename?: 'Query'
  pools: Array<{
    __typename?: 'FixedPricePool'
    address: string
    blockchain: string
    currentTime: string
    id: string
    whitelistAddress: string
    projectAdmin?: string | null
    price?: string | null
    poolStatus: PoolStatus
    poolType: PoolType
    minOrderSizeTargetToken: string
    account?: {
      __typename?: 'PoolAccount'
      account: string
      amountPaid: string
      claimAmount: string
      id: string
      idoTokenBalance: string
      isRegistered: boolean
      isWhitelisted?: boolean | null
      refundAmount: string
      targetTokenBalance: string
      userToReserve: string
      wave?: number | null
      waveStartTime?: string | null
      withdrawnAmount: string
      tier?: {
        __typename?: 'Tier'
        allocationMultiple: string
        coolOff: number
        index: number
        isSpecial?: boolean | null
        level: number
        maxAllocation?: string | null
        minStake?: string | null
        name: string
        participationTickets: string
      } | null
      vesting?: {
        __typename?: 'AccountVesting'
        available: Array<string>
        claimed: Array<string>
        totalAvailable: string
        totalClaimed: string
        unlocks: Array<string>
      } | null
    } | null
    idoToken: {
      __typename?: 'Token'
      address: string
      blockchain: string
      decimals: number
      id: string
      name: string
      symbol: string
      totalSupply: string
    }
    waves?: {
      __typename?: 'PoolWaves'
      currentWave?: number | null
      pipeline: Array<{
        __typename?: 'PoolWavePipeline'
        number: number
        start: string
      }>
    } | null
    vesting?: {
      __typename?: 'Vesting'
      currentPeriodIndex?: number | null
      unlockCheckpoints: Array<string>
      unlockPercentages: Array<string>
      viaAirdrop: boolean
    } | null
    tiers: Array<{
      __typename?: 'Tier'
      allocationMultiple: string
      coolOff: number
      index: number
      isSpecial?: boolean | null
      level: number
      maxAllocation?: string | null
      minStake?: string | null
      name: string
      participationTickets: string
    }>
    meta: {
      __typename?: 'PoolMeta'
      ROIAllTimeHigh?: string | null
      auditReport?: string | null
      brandBackground?: string | null
      brandLogo?: string | null
      coingecko?: string | null
      coinmarketcap?: string | null
      constantUSDTotalTarget?: string | null
      description: string
      discord?: string | null
      dueDiligenceReport?: string | null
      initialCirculationAmount?: string | null
      initialMarketCap?: string | null
      isIncubated?: boolean | null
      isKYCRequired: boolean
      markdown?: string | null
      medium?: string | null
      name: string
      position?: number | null
      prelaunchStart?: string | null
      priceAllTimeHigh?: string | null
      private: boolean
      registrationStart?: string | null
      sourceCode?: string | null
      subtitle?: string | null
      tags: Array<string>
      telegram?: string | null
      twitter?: string | null
      vestingDescription?: string | null
      video?: string | null
      visibility: boolean
      website?: string | null
      whitelistingStart?: string | null
      whitepaper?: string | null
      coolOffExplainedLink: string
      tiersExplainedLink: string
      roughTokenPriceUSD?: string | null
      participationExplainedLink: string
      constantUSDTokenPrice?: string | null
      secondaryMarkets: Array<{
        __typename?: 'SecondaryMarket'
        name: string
        sellStart?: string | null
        url: string
      }>
      team: Array<{
        __typename?: 'Member'
        avatar: string
        linkedIn: string
        name: string
        position: string
      }>
    }
    targetToken?: {
      __typename?: 'Token'
      address: string
      blockchain: string
      decimals: number
      id: string
      name: string
      symbol: string
      totalSupply: string
    } | null
    statistics: {
      __typename?: 'PoolStatistics'
      participantsCount: number
      registeredCount: number
    }
    progress: {
      __typename?: 'PoolProgress'
      softCapPercent?: string | null
      tokensSoftCap?: string | null
      tokensSold?: string | null
      tokensToSell?: string | null
      totalTarget?: string | null
      totalTargetUSD?: string | null
    }
    pipeline: {
      __typename?: 'PoolPipeline'
      finishTime?: string | null
      prelaunchTime?: string | null
      registrationTime?: string | null
      startTime?: string | null
      whitelistingTime?: string | null
    }
  }>
  stakingInfo: {
    __typename?: 'StakingInfo'
    address: string
    apy: string
    contract: string
    id: string
    sessionError?: string | null
    totalEmittedRewards: string
    totalRewardToDistribute?: string | null
    totalStaked: string
    unstakingFeeRatio: string
    account?: {
      __typename?: 'StakingAccount'
      account: string
      allowance: string
      rewardAvailable: string
      rewardClaimed: string
      rewardTotal: string
      rewardTotalUSD: string
      stakingBalance: string
      walletBalance: string
      stakeBooster?: {
        __typename?: 'StakeBooster'
        boosterUnlockTime: string
        stakeBoosterBalance: string
        stakeBoosterThreshold: string
      } | null
      tier?: {
        __typename?: 'StakingTier'
        allocationMultiple: string
        coolOff?: number | null
        index: number
        isSpecial?: boolean | null
        level: number
        minStake: string
        name: string
        participationTickets: string
        stakeDelta?: string | null
        ticketDelta?: string | null
      } | null
    } | null
    currentEpoch?: {
      __typename?: 'Epoch'
      rewardsPerSecond: string
      startTime: string
    } | null
    nextEpoch?: {
      __typename?: 'Epoch'
      rewardsPerSecond: string
      startTime: string
    } | null
    rewardToken: {
      __typename?: 'Token'
      address: string
      blockchain: string
      decimals: number
      id: string
      name: string
      symbol: string
      totalSupply: string
    }
    stakingToken: {
      __typename?: 'Token'
      address: string
      blockchain: string
      decimals: number
      id: string
      name: string
      symbol: string
      totalSupply: string
    }
    tiers: Array<{
      __typename?: 'StakingTier'
      allocationMultiple: string
      coolOff?: number | null
      index: number
      isSpecial?: boolean | null
      level: number
      minStake: string
      name: string
      participationTickets: string
      stakeDelta?: string | null
      ticketDelta?: string | null
    }>
  }
  kycInfo: {
    __typename?: 'KycInfo'
    generalLink: string
    lastSyncTime?: string | null
    rejectType?: KycRejectType | null
    status: KycStatus
    supportLink: string
    usInvestorsLink: string
    resubmitLink: string
  }
}

export const AuthDocument = gql`
  mutation Auth($input: AuthInput!) {
    auth(input: $input) {
      session
      address
    }
  }
`
export const GetAuthMessageDocument = gql`
  mutation GetAuthMessage($address: Address!) {
    getAuthMessage(address: $address)
  }
`
export const RegisterPoolParticipationDocument = gql`
  mutation RegisterPoolParticipation($input: RegisterPoolParticipationInput!) {
    registerPoolParticipation(input: $input) {
      reason
      success
    }
  }
`
export const GeneralInfoDocument = gql`
  query GeneralInfo($session: Session) {
    pools(session: $session) {
      account {
        account
        amountPaid
        claimAmount
        id
        idoTokenBalance
        isRegistered
        isWhitelisted
        refundAmount
        targetTokenBalance
        tier {
          allocationMultiple
          coolOff
          index
          isSpecial
          level
          maxAllocation
          minStake
          name
          participationTickets
        }
        userToReserve
        vesting {
          available
          claimed
          totalAvailable
          totalClaimed
          unlocks
        }
        wave
        waveStartTime
        withdrawnAmount
      }
      address
      blockchain
      currentTime
      id
      idoToken {
        address
        blockchain
        decimals
        id
        name
        symbol
        totalSupply
      }
      whitelistAddress
      waves {
        currentWave
        pipeline {
          number
          start
        }
      }
      vesting {
        currentPeriodIndex
        unlockCheckpoints
        unlockPercentages
        viaAirdrop
      }
      tiers {
        allocationMultiple
        coolOff
        index
        isSpecial
        level
        maxAllocation
        minStake
        name
        participationTickets
      }
      meta {
        ROIAllTimeHigh
        auditReport
        brandBackground
        brandLogo
        coingecko
        coinmarketcap
        constantUSDTotalTarget
        description
        discord
        dueDiligenceReport
        initialCirculationAmount
        initialMarketCap
        isIncubated
        isKYCRequired
        markdown
        medium
        name
        position
        prelaunchStart
        priceAllTimeHigh
        private
        registrationStart
        secondaryMarkets {
          name
          sellStart
          url
        }
        sourceCode
        subtitle
        tags
        team {
          avatar
          linkedIn
          name
          position
        }
        telegram
        twitter
        vestingDescription
        video
        visibility
        website
        whitelistingStart
        whitepaper
        coolOffExplainedLink
        tiersExplainedLink
        roughTokenPriceUSD
        participationExplainedLink
        constantUSDTokenPrice
      }
      targetToken {
        address
        blockchain
        decimals
        id
        name
        symbol
        totalSupply
      }
      statistics {
        participantsCount
        registeredCount
      }
      progress {
        softCapPercent
        tokensSoftCap
        tokensSold
        tokensToSell
        totalTarget
        totalTargetUSD
      }
      projectAdmin
      price
      poolStatus
      poolType
      pipeline {
        finishTime
        prelaunchTime
        registrationTime
        startTime
        whitelistingTime
      }
      minOrderSizeTargetToken
    }
    stakingInfo(session: $session) {
      account {
        account
        allowance
        rewardAvailable
        rewardClaimed
        rewardTotal
        rewardTotalUSD
        stakeBooster {
          boosterUnlockTime
          stakeBoosterBalance
          stakeBoosterThreshold
        }
        stakingBalance
        tier {
          allocationMultiple
          coolOff
          index
          isSpecial
          level
          minStake
          name
          participationTickets
          stakeDelta
          ticketDelta
        }
        walletBalance
      }
      address
      apy
      contract
      currentEpoch {
        rewardsPerSecond
        startTime
      }
      id
      nextEpoch {
        rewardsPerSecond
        startTime
      }
      rewardToken {
        address
        blockchain
        decimals
        id
        name
        symbol
        totalSupply
      }
      sessionError
      stakingToken {
        address
        blockchain
        decimals
        id
        name
        symbol
        totalSupply
      }
      tiers {
        allocationMultiple
        coolOff
        index
        isSpecial
        level
        minStake
        name
        participationTickets
        stakeDelta
        ticketDelta
      }
      totalEmittedRewards
      totalRewardToDistribute
      totalStaked
      unstakingFeeRatio
    }
  }
`
export const GeneralInfoWithKycDocument = gql`
  query GeneralInfoWithKYC($session: Session!) {
    pools(session: $session) {
      account {
        account
        amountPaid
        claimAmount
        id
        idoTokenBalance
        isRegistered
        isWhitelisted
        refundAmount
        targetTokenBalance
        tier {
          allocationMultiple
          coolOff
          index
          isSpecial
          level
          maxAllocation
          minStake
          name
          participationTickets
        }
        userToReserve
        vesting {
          available
          claimed
          totalAvailable
          totalClaimed
          unlocks
        }
        wave
        waveStartTime
        withdrawnAmount
      }
      address
      blockchain
      currentTime
      id
      idoToken {
        address
        blockchain
        decimals
        id
        name
        symbol
        totalSupply
      }
      whitelistAddress
      waves {
        currentWave
        pipeline {
          number
          start
        }
      }
      vesting {
        currentPeriodIndex
        unlockCheckpoints
        unlockPercentages
        viaAirdrop
      }
      tiers {
        allocationMultiple
        coolOff
        index
        isSpecial
        level
        maxAllocation
        minStake
        name
        participationTickets
      }
      meta {
        ROIAllTimeHigh
        auditReport
        brandBackground
        brandLogo
        coingecko
        coinmarketcap
        constantUSDTotalTarget
        description
        discord
        dueDiligenceReport
        initialCirculationAmount
        initialMarketCap
        isIncubated
        isKYCRequired
        markdown
        medium
        name
        position
        prelaunchStart
        priceAllTimeHigh
        private
        registrationStart
        secondaryMarkets {
          name
          sellStart
          url
        }
        sourceCode
        subtitle
        tags
        team {
          avatar
          linkedIn
          name
          position
        }
        telegram
        twitter
        vestingDescription
        video
        visibility
        website
        whitelistingStart
        whitepaper
        coolOffExplainedLink
        tiersExplainedLink
        roughTokenPriceUSD
        participationExplainedLink
        constantUSDTokenPrice
      }
      targetToken {
        address
        blockchain
        decimals
        id
        name
        symbol
        totalSupply
      }
      statistics {
        participantsCount
        registeredCount
      }
      progress {
        softCapPercent
        tokensSoftCap
        tokensSold
        tokensToSell
        totalTarget
        totalTargetUSD
      }
      projectAdmin
      price
      poolStatus
      poolType
      pipeline {
        finishTime
        prelaunchTime
        registrationTime
        startTime
        whitelistingTime
      }
      minOrderSizeTargetToken
    }
    stakingInfo(session: $session) {
      account {
        account
        allowance
        rewardAvailable
        rewardClaimed
        rewardTotal
        rewardTotalUSD
        stakeBooster {
          boosterUnlockTime
          stakeBoosterBalance
          stakeBoosterThreshold
        }
        stakingBalance
        tier {
          allocationMultiple
          coolOff
          index
          isSpecial
          level
          minStake
          name
          participationTickets
          stakeDelta
          ticketDelta
        }
        walletBalance
      }
      address
      apy
      contract
      currentEpoch {
        rewardsPerSecond
        startTime
      }
      id
      nextEpoch {
        rewardsPerSecond
        startTime
      }
      rewardToken {
        address
        blockchain
        decimals
        id
        name
        symbol
        totalSupply
      }
      sessionError
      stakingToken {
        address
        blockchain
        decimals
        id
        name
        symbol
        totalSupply
      }
      tiers {
        allocationMultiple
        coolOff
        index
        isSpecial
        level
        minStake
        name
        participationTickets
        stakeDelta
        ticketDelta
      }
      totalEmittedRewards
      totalRewardToDistribute
      totalStaked
      unstakingFeeRatio
    }
    kycInfo(session: $session) {
      generalLink
      lastSyncTime
      rejectType
      status
      supportLink
      usInvestorsLink
      resubmitLink
    }
  }
`

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string
) => Promise<T>

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType
) => action()

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper
) {
  return {
    Auth(
      variables: AuthMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<AuthMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AuthMutation>(AuthDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'Auth',
        'mutation'
      )
    },
    GetAuthMessage(
      variables: GetAuthMessageMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GetAuthMessageMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetAuthMessageMutation>(
            GetAuthMessageDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetAuthMessage',
        'mutation'
      )
    },
    RegisterPoolParticipation(
      variables: RegisterPoolParticipationMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<RegisterPoolParticipationMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RegisterPoolParticipationMutation>(
            RegisterPoolParticipationDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'RegisterPoolParticipation',
        'mutation'
      )
    },
    GeneralInfo(
      variables?: GeneralInfoQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GeneralInfoQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GeneralInfoQuery>(GeneralInfoDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GeneralInfo',
        'query'
      )
    },
    GeneralInfoWithKYC(
      variables: GeneralInfoWithKycQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GeneralInfoWithKycQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GeneralInfoWithKycQuery>(
            GeneralInfoWithKycDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GeneralInfoWithKYC',
        'query'
      )
    },
  }
}
export type Sdk = ReturnType<typeof getSdk>
